import {
  Box,
  makeStyles
} from "@material-ui/core";
import { useEffect, useState } from "react";


const useStyles = makeStyles(() => ({
  imgContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100px",
  }
}));

interface PropertyImageProps {
  property: any;
}

export const PropertyImage = ({ property }: PropertyImageProps) => {
  const [errorLoadingImage, setErrorLoadingImage] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    if (!property.propertyImage) return;

    const img = new Image();
    img.src = property.propertyImage;

    img.onload = () => setErrorLoadingImage(false);
    img.onerror = () => setErrorLoadingImage(true);
  }, [property.propertyImage]);

  return (<Box className={classes.imgContainer}>
    {property.propertyImage && !errorLoadingImage ? (
      <div style={{
        width: "100%",
        height: "130px",
        backgroundImage: `url(${property.propertyImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}></div>
    ) : (
      <p>No Image Available</p>
    )}
  </Box>);
}